import GetHeroIcon from "../../../utils/getHeroIcon";

const EmptyState = () => {
  return (
    <div className="flex flex-col justify-center items-center  gap-3 overflow-hidden h-full border-4-">
      <GetHeroIcon
        name={"BellIcon"}
        className="w-12 h-12"
        variant="outline"
        aria-hidden="true"
      />
      <div className="text-body text-base font-semibold">
        Nothing new to see here yet
      </div>
    </div>
  );
};

export default EmptyState;
